const Pricing = () => {
  return (
    <div className="container background_light">
      <div className="column g1 center">
        <h2>Pricing</h2>
        <div
          className="card column g1 background_white"
          style={{ maxWidth: "32rem" }}
        >
          <div className="flex between">
            <p>
              <strong>Just you</strong>
            </p>
            <span>$125</span>
          </div>
          <div className="flex between">
            <p>
              <strong>2 – 24</strong> employees
            </p>
            <span>$250</span>
          </div>
          <div className="flex between">
            <p>
              <strong>25 – 49</strong> employees
            </p>
            <span>$500</span>
          </div>
          <div className="flex between">
            <p>
              <strong>50+</strong> employees
            </p>
            <span>$750</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Pricing;
